// extracted by mini-css-extract-plugin
module.exports = {"rotate":"styles_rotate__LIOeL","rotation":"styles_rotation__RssB3"};